export const POLICY_LAST_UPDATED = {
  terms: '2024-02-02',
  privacy: '2024-11-11',
  dpa: '2024-08-06'
}

const parseDate = (isoDate) => new Date(`${isoDate}T00:00:00Z`)

const policyDates = Object.values(POLICY_LAST_UPDATED).map((date) => parseDate(date))

const reduceDates = (comparator) =>
  policyDates.reduce((acc, current) => (comparator(current, acc) ? current : acc))

const earliestPolicyUpdate = reduceDates((current, acc) => current < acc)
const latestPolicyUpdate = reduceDates((current, acc) => current > acc)

export const EARLIEST_POLICY_UPDATE_ISO = earliestPolicyUpdate.toISOString()
export const LATEST_POLICY_UPDATE_ISO = latestPolicyUpdate.toISOString()
